var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUploadImage = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5933",
    "data-name": "Group 5933",
    transform: "translate(-37 -567)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6410",
    "data-name": "Rectangle 6410",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(37 567)",
    fill: "#82cecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add_2_",
    "data-name": "add (2)",
    d: "M13.613,0H2.521A2.524,2.524,0,0,0,0,2.521v8.824a2.524,2.524,0,0,0,2.521,2.521H8.508a.63.63,0,0,0,.5-1.016L7.358,10.719l4.569-5.812,2.947,3.515V9.485a.63.63,0,1,0,1.261,0V2.521A2.524,2.524,0,0,0,13.613,0ZM12.395,3.5a.63.63,0,0,0-.978.015L6.563,9.691,4.91,7.556a.63.63,0,0,0-.5-.245h0a.63.63,0,0,0-.5.246L2.525,9.36a.63.63,0,0,0,1,.769l.889-1.156,2.811,3.632h-4.7a1.262,1.262,0,0,1-1.261-1.261V2.521A1.262,1.262,0,0,1,2.521,1.261H13.613a1.262,1.262,0,0,1,1.261,1.261V6.46ZM4.412,2.269A1.891,1.891,0,1,0,6.3,4.16,1.893,1.893,0,0,0,4.412,2.269Zm0,2.521a.63.63,0,1,1,.63-.63A.631.631,0,0,1,4.412,4.79Zm11.723,7.216a.63.63,0,0,1-.63.63H13.771V14.37a.63.63,0,0,1-1.261,0V12.637H10.777a.63.63,0,1,1,0-1.261h1.733V9.643a.63.63,0,1,1,1.261,0v1.733H15.5A.63.63,0,0,1,16.134,12.006Zm0,0",
    transform: "translate(49 580)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload-image.ade807c3.svg";
export { ForwardRef as ReactComponent };